/**
 * Handy: „Zurück" aus der Mail-Vollansicht führt zur Liste (Knopf, App-Pfeil,
 * Browser-/iOS-Geste). Beim Öffnen kommt ein eigener Verlaufseintrag dazu; wird
 * die Mail anders geschlossen, wird er wieder abgebaut. Rein, damit testbar.
 */
export const LESEN_MARKE = "kmvsMailLesen";

type Zustand = Record<string, unknown> | null | undefined;

export function istLeseEintrag(st: Zustand): boolean {
    return !!st?.[LESEN_MARKE];
}

/** Was mit dem Verlauf zu tun ist, wenn sich „Mail offen" ändert. */
export function leseVerlaufSchritt(lesenOffen: boolean, st: Zustand): "push" | "back" | null {
    if (lesenOffen && !istLeseEintrag(st)) return "push";
    if (!lesenOffen && istLeseEintrag(st)) return "back";
    return null;
}

/**
 * Der neue Eintrag: der Router-Zustand mit `idx + 1` — der App-Pfeil
 * (`smartBack`) sieht dann einen Vorgänger und geht per navigate(-1) genau
 * einen Schritt zurück, also zur Liste.
 */
export function leseEintrag(st: Zustand): Record<string, unknown> {
    const idx = typeof st?.idx === "number" ? st.idx + 1 : 1;
    return { ...(st ?? {}), idx, key: `${String(st?.key ?? "mail")}-lesen`, [LESEN_MARKE]: true };
}
